import { render, staticRenderFns } from "./playerThisSeasonRecord.vue?vue&type=template&id=3166eb16&scoped=true"
import script from "./playerThisSeasonRecord.vue?vue&type=script&lang=js"
export * from "./playerThisSeasonRecord.vue?vue&type=script&lang=js"
import style0 from "./playerThisSeasonRecord.vue?vue&type=style&index=0&id=3166eb16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3166eb16",
  null
  
)

export default component.exports